import { atom } from 'recoil';
import { paymentInformationSelector } from '../selectors/paymentInformationSelector';
import type { PaymentInformationDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/payment/';

export const fetchedPaymentInformationAtom = atom<PaymentInformationDTO>({
    key: 'fetchedPaymentInformation',
    default: paymentInformationSelector
});
